<template>
  <div :class="{ 'calendar-trip-details': true, 'is-loading': !loadedFlights, 'is-visible': isVisible }">
    <d-row class="mx-0 w-100">
      <h4 class="mb-0 mt-0 pr-5 d-flex">
        Trip schedule

        <d-button
          theme="primary"
          outline
          class="ml-auto"
          @click.prevent="$router.push('/dashboard/trips/' + tripId)">
          <i class="material-icons">edit</i>
          Edit trip
        </d-button>

        <a
          href="#close"
          class="calendar-trip-details-close"
          @click.prevent="close">
          <i class="material-icons">clear</i>
        </a>
      </h4>
    </d-row>

    <table class="mt-4 mb-0 table table-bordered">
      <thead>
        <tr>
          <th class="text-center" style="width: 200px;">Handler</th>
          <th class="text-center" style="width: 80px;">ETA</th>
          <th class="text-center" style="width: 100px;">DOF</th>
          <th class="text-center" style="width: 240px;">Location</th>
          <th class="text-center" style="width: 100px;">DOF</th>
          <th class="text-center" style="width: 80px;">ETD</th>
          <th class="text-center" style="width: 200px;">Handler</th>
        </tr>
      </thead>
    </table>

    <div
      v-for="(flight, index) of flights"
      :key="'flight-item-' + index"
      class="flight"
      :data-index="index">
      <div class="flight-arrival-handler text-center">
        {{ getHandlerById(flight.arrival_handler_id) }}
      </div>
      <div class="flight-arrival-time">
        {{ flight.arrival_time }}
      </div>
      <div class="flight-arrival-date">
        {{ flight.arrival_date | formatDate }}
      </div>
      <div class="flight-departure-airport">
        {{ getAirportById(flight.departure_airport_id) }}
      </div>
      <div class="flight-departure-date">
        {{ flight.departure_date | formatDate }}
      </div>
      <div class="flight-departure-time">
        {{ flight.departure_time }}
      </div>
      <div class="flight-departure-handler">
        {{ getHandlerById(flight.departure_handler_id) }}
      </div>
      <div
        v-if="index === flights.length - 1"
        class="flight-arrival-airport">
        {{ getAirportById(flight.arrival_airport_id) }}
      </div>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'calendar-trip-details',
  props: [
    'airports',
    'handlers'
  ],
  filters: {
    formatDate (input) {
      if (!input) {
        return '';
      }

      return [input.getDate(), input.getMonth() + 1, input.getFullYear()].map(n => n < 10 ? '0' + n : n).join('/');
    }
  },
  data () {
    return {
      isVisible: false,
      tripId: 0,
      flights: [],
      loadedFlightsData: [],
      loadError: false,
      loadedFlights: false
    };
  },
  mounted () {
    this.$bus.$on('calendar-trip-details-show', this.show);
    this.$bus.$on('calendar-trip-details-close', this.close);
    this.$bus.$on('calendar-trip-details-change-trip', this.changeTrip);
  },
  methods: {
    show (tripID) {
      this.tripId = parseInt(tripID, 10);
      this.isVisible = true;
      this.loadFlights();
    },
    close () {
      this.isVisible = false;
      this.$bus.$emit('calendar-trip-details-pane-close');
    },
    changeTrip (tripID) {
      if (tripID !== this.tripId) {
        this.tripId = tripID;
        this.loadFlights();
      }
    },
    loadFlights () {
      let self = this;
      this.flights = [];
      this.loadedFlights = false;

      FormUtils.loadAdditionalData(this, {
        endpoint: '/trips/flights/items',
        params: {
          pagination: 0,
          where: {
            trip_id: this.tripId
          },
          order: {
            column: 'departure_date',
            direction: 'ASC'
          }
        },
        loadedKey: 'loadedFlights',
        outputKey: 'loadedFlightsData',
        errorKey: 'loadError',
        successAction (response) {
          for (let i = 0; i < response.length; i++) {
            let flightData = {
              id: response[i].id,
              departure_airport_id: response[i].departure_airport_id,
              departure_date: new Date(response[i].departure_date.split(' ')[0]),
              departure_time: response[i].departure_date.split(' ')[1].replace(/\:/g, '').substr(0, 4),
              departure_handler_id: response[i].departure_handler_id,
              arrival_airport_id: response[i].arrival_airport_id,
              arrival_date: new Date(response[i].arrival_date.split(' ')[0]),
              arrival_time: response[i].arrival_date.split(' ')[1].replace(/\:/g, '').substr(0, 4),
              arrival_handler_id: response[i].arrival_handler_id,
              errors: []
            };

            if (flightData.departure_handler_id === 0) {
              flightData.departure_handler_id = null;
            }

            if (flightData.arrival_handler_id === 0) {
              flightData.arrival_handler_id = null;
            }

            self.flights.push(flightData);
          }

          setTimeout(() => {
            self.loadedFlights = true;
          }, 0);
        }
      });
    },
    getHandlerById (handlerID) {
      if (!handlerID) {
        return '-';
      }

      let foundedHandler = this.handlers.filter(handler => handler.id === handlerID);

      if (foundedHandler.length) {
        return foundedHandler[0].name;
      }

      return '???';
    },
    getAirportById (airportID) {
      let index = this.airports.findIndex(airport => airport.id === airportID);

      if (index > -1) {
        return this.airports[index].iata;
      }

      return '???';
    }
  },
  beforeDestroy () {
    this.$bus.$off('calendar-trip-details-show', this.show);
    this.$bus.$off('calendar-trip-details-close', this.close);
    this.$bus.$off('calendar-trip-details-change-trip', this.changeTrip);
  }
}
</script>

<style lang="scss" scoped>
.calendar-trip-details {
  background: #f5f5f5;
  border-top: 1px solid #ddd;
  bottom: -300px;
  height: 300px;
  left: 200px;
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  position: fixed;
  transition: all .25s ease-out;
  width: calc(100% - 600px);
  z-index: 10;

  &.is-visible {
    bottom: 0;
  }

  &.is-loading {
    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }

  h4,
  table {
    margin: 0 auto;
    width: 1000px;
  }

  h4 {
    position: relative;
  }

  .row {
    margin: 0!important;
  }

  table th {
    background: #eee;
    font-weight: bold;
  }

  .flight {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    margin: -1px auto 0 auto;
    pointer-events: none;
    position: relative;
    width: 1000px;

    & + .flight {
      margin-top: -40px;
    }

    &-arrival-handler,
    &-arrival-date,
    &-arrival-time,
    &-arrival-airport,
    &-departure-handler,
    &-departure-date,
    &-departure-time,
    &-departure-airport {
      align-items: center;
      background: #fff;
      border: 1px solid #dee2e6;
      border-top: none;
      border-left: none;
      display: flex;
      height: 40px;
      justify-content: center;
      pointer-events: auto;
    }

    &-arrival-handler {
      border-left: 1px solid #dee2e6;
      margin-top: 40px;
      width: 200px;
    }

    &-arrival-date {
      margin-top: 40px;
      width: 100px;
    }

    &-arrival-time {
      margin-top: 40px;
      width: 80px;
    }

    &-arrival-airport {
      left: 380px;
      position: absolute;
      top: 40px;
      width: 240px;
    }

    &-departure-handler {
      width: 200px;
    }

    &-departure-date {
      width: 100px;
    }

    &-departure-time {
      width: 80px;
    }

    &-departure-airport {
      width: 240px;
    }

    &[data-index="0"] {
      .flight-arrival-handler,
      .flight-arrival-date,
      .flight-arrival-time {
        border-top: 1px solid #dee2e6;
      }

      .flight-departure-airport {
        border-left: 1px solid #dee2e6;
        margin-left: -1px;
        width: 241px;
      }
    }
  }

  &-close {
    border: 1px solid #ccc;
    border-radius: 50%;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    margin-left: auto;
    position: absolute;
    right: 0;
    text-align: center;
    top: 16px;
    transform: translateY(-50%);
    width: 24px;

    i {
      position: relative;
      top: 1px;
    }
  }
}
</style>
